import * as React from 'react';
import { PHONE_MEDIA } from '../vars';

export function useIsPhoneSize(): boolean {
  const [isPhoneSize, setIsPhoneSize] = React.useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= PHONE_MEDIA;
  });

  React.useEffect(() => {
    const handleResize = () => {
      setIsPhoneSize(window.innerWidth <= PHONE_MEDIA);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isPhoneSize;
}
